module.exports = __webpack_public_path__ + "img/pirates-preview.c9be8953.png";